import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { Router } from 'react-router-dom';
import ReduxToastr from 'react-redux-toastr';
import { getDomainName } from 'app/utils/CommonUtils';
import URLMigration from 'app/components/URLMigration';
import Spinner from 'app/components/Spinner';
import 'app/assets/css/toastr.css';
import 'app/index.css';
import '@yubi/yb-module-auth/package/module-assets/icons/style.css';

import { ApolloProvider } from '@apollo/client';
import client from 'app/utils/graphql';
import amplitude from 'amplitude-js';

import App from 'app/containers/App';
// import registerServiceWorker from './registerServiceWorker';
import loadThirdPartyServices from 'app/thirdpartyservices'; //eslint-disable-line
import configureStore from 'app/store/configureStore';
import history from 'app/utils/myHistory';
import NotificationProvider from 'app/components/Notifications/NotificationProvider';
import AmplitudeProvider from 'app/components/Amplitude/AmplitudeProvider';
import { getActiveUserId } from 'app/actions/AuthedActions';
import PublicRoutesWrapper from 'app/components/PublicRoutesWrapper';
import WebEngageProvider from 'app/components/WebEngage/WebEngageProvider';
import YubiDomainResolver from 'app/components/YubiDomainResolver';

const AMPLITUDE_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY;

const store = configureStore(history);

const parseDomain = () => {
    const [subDomain, domain, type] = window.location.host?.split('.');
    return { subDomain, domain, type };
};

const getCurrentDomain = () => {
    const { domain } = parseDomain();
    return domain;
};

const getEnv = (endPoint, resolveDomain = true) => {
    if (endPoint?.startsWith('/')) return endPoint;
    if (resolveDomain && getCurrentDomain() === 'go-yubi') {
        return endPoint?.replace('credavenue', 'go-yubi');
    }
    if (resolveDomain && getCurrentDomain() === 'credavenue') {
        return endPoint?.replace('go-yubi', 'credavenue');
    }
    return endPoint;
};

ReactDOM.render(
    <Provider store={store}>
        <NotificationProvider>
            <ApolloProvider client={client}>
                <AmplitudeProvider
                    amplitudeInstance={amplitude.getInstance()}
                    apiKey={AMPLITUDE_KEY}
                    userId={getActiveUserId()}
                    config={{
                        apiEndpoint: getEnv(process.env.REACT_APP_AMPLITUDE_ENDPOINT),
                    }}
                >
                    <WebEngageProvider>
                        <YubiDomainResolver>
                            <Router history={history}>
                                <ConnectedRouter history={history}>
                                    <URLMigration
                                        oldDomain={process.env.REACT_APP_MP_DOMAIN_OLD}
                                        newUrl={process.env.REACT_APP_POOL_HOST}
                                        currentDomain={getDomainName().domain}
                                        Loader={Spinner}
                                    >
                                        <PublicRoutesWrapper history={history}>
                                            <App />
                                        </PublicRoutesWrapper>
                                    </URLMigration>
                                </ConnectedRouter>
                            </Router>
                            <ReduxToastr
                                timeOut={4000}
                                newestOnTop={false}
                                preventDuplicates
                                position="top-right"
                                // transitionIn="fadeIn"
                                // transitionOut="fadeOut"
                                progressBar={false}
                            />
                        </YubiDomainResolver>
                    </WebEngageProvider>
                </AmplitudeProvider>
            </ApolloProvider>
        </NotificationProvider>
    </Provider>,
    document.getElementById('root'),
);
// registerServiceWorker();
